import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '../store/store';

export interface TrialView {
  title: string;
  subtitle: string;
  name: string;
  icon: string;
  trialDays: number;
  dueDate: Date | null;
  sourcePrice: number;
  ratePlan: string;
  sourceRatePlan: string;
  migrationPathId: string;
}

export const selectTrialLoading = (state: RootState) => state.trial.loading;
export const selectTrialInitialized = (state: RootState) =>
  state.trial.initialized;

const selectDescription = (state: RootState) => state.trial.description;
const selectTrialCatalog = (state: RootState) => state.trial.trialCatalog;
const selectSourceCatalog = (state: RootState) => state.trial.sourceCatalog;
const selectCurrencyCode = (state: RootState) =>
  state.app.localization?.currencyCode ?? '';

export const selectTrialView = createSelector(
  [
    selectDescription,
    selectTrialCatalog,
    selectSourceCatalog,
    selectCurrencyCode,
  ],
  (
    description,
    trialCatalog,
    sourceCatalog,
    currencyCode,
  ): TrialView | null => {
    if (!description) {
      return null;
    }

    const { product } = description;
    const trialDays = trialCatalog?.specificBillingPeriod ?? 0;

    const dueDate = trialDays ? new Date() : null;
    if (dueDate) {
      dueDate.setDate(dueDate.getDate() + trialDays);
    }

    const sourcePrice =
      sourceCatalog?.pricing.find((p) => p.currency === currencyCode)?.price ??
      0;

    return {
      title: product.title ?? '',
      subtitle: product.subtitle ?? '',
      name: product.name ?? '',
      icon: product.icon ?? 'vray.svg',
      trialDays,
      dueDate,
      sourcePrice,
      ratePlan: product.ratePlan,
      sourceRatePlan: product.sourceRatePlan,
      migrationPathId: product.migrationPathId,
    };
  },
);
